/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { useDashboardStore } from "@/stores/useDashboardStore";

import { useDashboardContext } from "../../../../context/dashoard/DashboardProvider";
import { useStyles as sharedStyles, useMediaQueries } from "../../../../shared";
import RectangleLoader from "../../../../shared/components/loaders/RectangleLoader";
import CardWrapper from "../../CardWrapper/CardWrapper";
import { CCExpirationObjectDto } from "../../types";

import CCExpirationAccordionItem from "./CCExpirationAccordionItem/CCExpirationAccordionItem";
import useCCExpirationComponents from "./hooks/useCCExpirationComponents";
import useCCexpiration from "./hooks/useCCexpiration";

const CCExpiration = () => {
  const { setDashboardWidgets } = useDashboardContext();

  const { isLoading: isCCExpirationLoading } = useCCexpiration();
  const { expiredCardsBadge, nearExpiryCardsBadge, upcomingExpiryCardsBadge } =
    useCCExpirationComponents();

  const { t } = useTranslation();
  const { toSm } = useMediaQueries();

  const {
    ccExpiry: ccExpiryData,
    isDashboardLoading,
    ccExpiryError
  } = useDashboardStore();

  const [expanded, setExpanded] = useState<string>("");

  const { scrollableCardContainer } = sharedStyles();

  const isLoading = isDashboardLoading || isCCExpirationLoading;

  useEffect(() => {
    setDashboardWidgets(prevWidgets => ({
      ...prevWidgets,
      showCCExpiration: true
    }));
  }, [setDashboardWidgets]);

  const handleCollapse = (panel: string, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : "");
  };

  const hasItemsInsideArray = (array?: CCExpirationObjectDto[]) =>
    (array && array.length > 0) || false;

  return (
    <CardWrapper
      isTopSection={!toSm}
      cardTitle={t("Dashboard##company cards expiration")}
      isInnerCard
      isLoading={isLoading}
      isError={ccExpiryError}
    >
      {isLoading ? (
        <RectangleLoader
          width="100%"
          height="100%"
          testId="cc-expiry-card-loader"
        />
      ) : (
        ccExpiryData && (
          <div css={css(scrollableCardContainer)}>
            <CCExpirationAccordionItem
              expandedPanel={expanded}
              title={nearExpiryCardsBadge(ccExpiryData?.nearExpiry)}
              index={0}
              onCollapse={handleCollapse}
              expirydata={ccExpiryData?.nearExpiry}
              isExpandable={hasItemsInsideArray(ccExpiryData?.nearExpiry)}
            />
            <CCExpirationAccordionItem
              expandedPanel={expanded}
              title={upcomingExpiryCardsBadge(ccExpiryData?.upcomingExpiry)}
              index={1}
              onCollapse={handleCollapse}
              expirydata={ccExpiryData?.upcomingExpiry}
              isExpandable={hasItemsInsideArray(ccExpiryData?.upcomingExpiry)}
            />
            <CCExpirationAccordionItem
              expandedPanel={expanded}
              title={expiredCardsBadge(ccExpiryData?.expired)}
              index={2}
              onCollapse={handleCollapse}
              expirydata={ccExpiryData?.expired}
              isExpandable={hasItemsInsideArray(ccExpiryData?.expired)}
            />
          </div>
        )
      )}
    </CardWrapper>
  );
};

export default CCExpiration;
